__turbopack_context__.v({
  "heading": "HubSpotForm-module__X7pxja__heading",
  "wrapper": "HubSpotForm-module__X7pxja__wrapper",
});
